import { HYDRATE } from 'next-redux-wrapper';
import { categoryNameToUrl } from 'utils/url';

import type { CmsReducerStateType } from '../../types/cms.types';
import { CMS_ITEM_NAME } from '../../utils/cms/cms-item-names';
import { CMS_ACTIONS } from '../action-types/cms.action-types';

export type CmsReducer = CmsReducerStateType;

export const initState: CmsReducerStateType = Object.freeze({
  [CMS_ITEM_NAME.DYNAMIC_STATISTICS]: {
    statistics: {
      totalRegisteredUsers: 0,
      totalPaidOut: 0,
      productsSold: 0,
      rating: 0,
    },
  },
});

export const cmsReducer = (state = initState, action) => {
  switch (action.type) {
    // required for server-side init
    case HYDRATE: {
      return { ...state, ...action.payload.cms };
    }
    case CMS_ACTIONS.DATA_SAVED: {
      if (!action.payload) {
        return state;
      }

      const { data, name } = action.payload;

      return {
        ...state,
        [name]: data,
      };
    }
    case CMS_ACTIONS.ALL_DATA_SAVED: {
      const { categories } = action.payload;

      let categoriesData = [];

      if (categories?.categories) {
        categoriesData = categories.categories.map((category) => ({
          ...category,
          apiEndpoint: encodeURI(category.tag),
          categoryId: category.categoryId || null,
          brandId: category.brandId || null,
          // The official URL segment is always the English slug, so every in-app link
          // lands on the canonical category URL instead of eating a 301. `name` arrives
          // already localised, hence the explicit English lookup.
          feEndpoint: categoryNameToUrl(category.titlesMultilang?.en || category.name),
        }));
      }

      return {
        ...action.payload,
        categories: categoriesData,
      };
    }
    default: {
      return state;
    }
  }
};
